import React, {Component} from 'react';
import PageTemplate from 'components/common/PageTemplate';
import ItemFilterContainer from 'containers/items/ItemFilterContainer';
import ItemListContainer from 'containers/items/ItemListContainer';

import { Helmet, HelmetProvider } from "react-helmet-async";

import Adsense970250 from 'components/adsense/Adsense970250';
import AdblockModal from 'components/adsense/AdblockModal/AdblockModal';


class ItemsPage extends Component {
  render() {
    return (
      <PageTemplate>
        <AdblockModal/>
        <HelmetProvider>
          <Helmet>
            <title>이터널시티 무기정보</title>
            <meta name="description" content="착용부위별 등급별 이터널시티 무기 아이템정보. 불법무기 CL무기 목록조회" />
          </Helmet>
        </HelmetProvider>
        <Adsense970250/>
        <ItemFilterContainer/>
        <ItemListContainer/>
      </PageTemplate>
    );
  }
};

export default ItemsPage;